import * as React from "react";

export const useToggle = (defaultActive?: boolean) => {
  const [active, setActive] = React.useState(defaultActive || false);
  const toggle = React.useCallback(() => {
    setActive((prevState) => !prevState);
  }, []);

  const unactivate = React.useCallback(() => {
    setActive(false);
  }, []);

  return { active, toggle, unactivate };
};
